import Button from '@jetbrains/ring-ui-built/components/button/button'
import Link from '@jetbrains/ring-ui-built/components/link/link'
import {useCallback} from 'react'

import {useSetUserProperty} from '../../../../../hooks/useSetUserProperty'
import {useBooleanUserProperty} from '../../../../../hooks/useUserProperty'
import {
  interviewRecruitmentBannerAdditionalMessage,
  interviewRecruitmentBannerButtonName,
  interviewRecruitmentBannerLink,
  interviewRecruitmentBannerMainMessage,
  isPipelinesInterviewRecruitmentBannerEnabled,
} from '../../../../../utils/featureToggles'
import {UserProperties} from '../../../../../utils/userProperties'

import styles from './PipelinesInterviewRecruitmentBanner.module.css'

function PipelinesInterviewRecruitmentBanner() {
  const setUserProperty = useSetUserProperty()

  const isShowInterviewRecruitmentBanner = useBooleanUserProperty(
    UserProperties.SHOW_PIPELINES_INTERVIEW_RECRUITMENT_BANNER,
    true,
  )

  const dismiss = useCallback(
    () => setUserProperty(UserProperties.SHOW_PIPELINES_INTERVIEW_RECRUITMENT_BANNER, 'false'),
    [setUserProperty],
  )

  if (
    !isPipelinesInterviewRecruitmentBannerEnabled ||
    !isShowInterviewRecruitmentBanner ||
    !interviewRecruitmentBannerLink ||
    !interviewRecruitmentBannerButtonName ||
    !interviewRecruitmentBannerMainMessage ||
    !interviewRecruitmentBannerAdditionalMessage
  ) {
    return null
  }

  return (
    <>
      <div className={styles.banner}>
        <div className={styles.message}>
          <span className={styles.mainMessage}>{interviewRecruitmentBannerMainMessage}</span>
          {interviewRecruitmentBannerAdditionalMessage}
        </div>
        <div>
          <Link
            className={styles.scheduleInterviewLink}
            href={interviewRecruitmentBannerLink}
            target="_blank"
            rel="noreferrer"
          >
            {interviewRecruitmentBannerButtonName}
          </Link>
          <Button className={styles.dismissButton} onClick={dismiss} inline>
            {'Dismiss'}
          </Button>
        </div>
      </div>
    </>
  )
}

export default PipelinesInterviewRecruitmentBanner
